export default {"src":"/_next/static/media/icon-level-4.1bc2fec5.svg","height":25,"width":52};